module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAx0lEQVQokbXSQUqCURQF4K/ff9Ck1tAWXIfDpkE7aBONBSMnDQQXEISbaJZQgYaog0CwDFJnQUkD7+BlFo+gA4d33333vHMGd6dxfjHCE1rBLBQ4xR7OUMkVlmhjjisMsfplfj8+n5XR6MZ5kGn4XETxiJfcmLgvkkv3x7Hv6P1V+MXx5r8d3zBIhWO8Zgg7eC83mteoRT1BP/gQ7GHKegFSHOEYlyFMsYsqZvgoNh4P0UB9S8RmJDphvasphljgdovwDsuI7BPT+S6GoK4YJwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mall_icon.png
// module id = Aw6u
// module chunks = 1